var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7494 3.30042C22.6828 3.71709 22.6494 4.13375 22.6494 4.55042C22.6494 8.30042 25.6828 11.3321 29.4161 11.3321C29.8328 11.3321 30.2328 11.2838 30.6494 11.2171V24.6654C30.6494 30.3171 27.3161 33.6671 21.6494 33.6671H9.33443C3.6661 33.6671 0.332764 30.3171 0.332764 24.6654V12.3338C0.332764 6.66709 3.6661 3.30042 9.33443 3.30042H22.7494ZM23.0844 13.4338C22.6328 13.3838 22.1844 13.5838 21.9161 13.9504L17.8844 19.1671L13.2661 15.5338C12.9828 15.3171 12.6494 15.2321 12.3161 15.2671C11.9844 15.3171 11.6844 15.4988 11.4828 15.7654L6.5511 22.1838L6.44943 22.3338C6.1661 22.8654 6.29943 23.5488 6.79943 23.9171C7.03276 24.0671 7.28276 24.1671 7.5661 24.1671C7.9511 24.1838 8.3161 23.9821 8.54943 23.6671L12.7328 18.2821L17.4828 21.8504L17.6328 21.9488C18.1661 22.2321 18.8328 22.1004 19.2161 21.5988L24.0328 15.3838L23.9661 15.4171C24.2328 15.0504 24.2828 14.5838 24.0994 14.1671C23.9178 13.7504 23.5161 13.4671 23.0844 13.4338ZM29.6496 0.333252C31.8663 0.333252 33.6663 2.13325 33.6663 4.34992C33.6663 6.56659 31.8663 8.36659 29.6496 8.36659C27.4329 8.36659 25.6329 6.56659 25.6329 4.34992C25.6329 2.13325 27.4329 0.333252 29.6496 0.333252Z",
    fill: "#272727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalBalance);
export default __webpack_public_path__ + "static/media/total_balance.b3a816dd222ce14d8600e15c7f2e00fb.svg";
export { ForwardRef as ReactComponent };